import { render } from "./edit.vue?vue&type=template&id=2b31b25c"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vendor/vvg/forum/resources/vue/topic/edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2b31b25c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2b31b25c', __exports__)) {
    console.log('reload')
    api.reload('2b31b25c', __exports__)
  }
  
  module.hot.accept("./edit.vue?vue&type=template&id=2b31b25c", () => {
    console.log('re-render')
    api.rerender('2b31b25c', render)
  })

}


export default __exports__